import Vue from 'vue';
import VueI18n from 'vue-i18n';

import ElementLocale from 'element-ui/lib/locale';

/*  引入语言包 */
import messages from './langs';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.lang || 'cn',
  messages
});
ElementLocale.i18n(function(key, value) {i18n.t(key, value)} );

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js